export const fmtUSD = (n) => `$${Number(n || 0).toLocaleString()}`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString() : "—");
